module.exports = __webpack_public_path__ + "img/no-data.9ffafe59.png";